function homePage(dispatch) {
    dispatch({ type: "newuserfalse" });
    dispatch({ type: "recruitertrue" });
    dispatch({ type: "recruiterCandidatetrue"})
    dispatch({ type: "freelancefalse"})
}

export { homePage };